import { Route, Routes } from 'react-router-dom';
import './App.css';
import "./assets/css/General/fontStyles.css";
import "./assets/css/General/variables.css";
import Home from './screens/Buyer/home/Home';
import Properties from './screens/Buyer/properties/Properties';
import AdminDashboard from 'screens/Admin/dashboard/AdminDashboard';
import BuyerProperty from 'screens/Buyer/buyerproperty/BuyerProperty';
import BuyerDashboard from 'screens/Buyer/Dashboard/BuyerDashboard';
import AllBuyers from 'screens/Admin/buyer/AllBuyers';
import BuyerSideBar from 'components/Buyer/buyersidebar/BuyerSideBar';
import AllSellers from 'screens/Admin/sellers/AllSellers';
import Analytics from 'screens/Admin/analytics/AnalyticsKpi';
import DisputeManagement from 'screens/Admin/dispute/DisputeManagement';
import AdminProfile from 'screens/Admin/adminprofile/AdminProfile';
import AuthLogin from 'screens/Admin/auth/AuthLogin';
import Notification from 'screens/Admin/notification/Notification';
import SubAdmin from 'screens/Admin/subadmin/SubAdmin';
import SellerDashboard from 'screens/seller/dashboard/SellerDashboard';
import BuyerHeader from './components/Buyer/buyerheader/BuyerHeader';
import PropertyDetails from 'screens/Buyer/properties/propertydetails/PropertyDetails';
import BuyerMap from 'screens/Buyer/buyermap/BuyerMap';
import BuyerChats from 'screens/Buyer/buyerchats/BuyerChats';
import BuyerSupport from 'screens/Buyer/buyersupport/BuyerSupport';
import BuyerLogin from 'screens/Buyer/buyerauth/BuyerLogin';
import BuyerSignup from 'screens/Buyer/buyerauth/buyersignup';
import About from 'screens/Buyer/about/About';
import Contact from 'screens/Buyer/contact/Contact';
import BuyerProfile from 'screens/Buyer/buyerprofile/BuyerProfile';
import Blogs from 'screens/Buyer/blogs/Blogs';
import BuyerNotifications from 'screens/Buyer/buyernotifiactions/BuyerNotifications';
import ManageBlogs from 'screens/Admin/blogs/ManageBlogs';
import Managefaqs from 'screens/Admin/faqs/ManageFaqs';
import Agents from 'screens/Buyer/agents/Agents';
import BuyerRequest from 'screens/Buyer/buyervisitreq/BuyerRequest';
import ContactManagement from 'screens/Admin/contact/ContactManagement';
import AdminKyc from 'screens/Admin/adminkyc/AdminKyc';
import SellerMessages from 'screens/seller/sellermessages/SellerMessages';
import HelpSupports from 'screens/seller/help-supports/HelpSupports';
import SellerProfile from 'screens/seller/sellersprofile/SellersProfile';
import Notifications from 'screens/seller/notification/Notification';
import SellerLogin from 'screens/seller/sellerauth/Sellerlogin';
import Sellersignup from 'screens/seller/sellerauth/Sellersignup';
import SellerSettings from 'screens/seller/sellersetting/SellerSetting';
import SellerKYC from 'screens/seller/sellerkyc/SellerKyc';
import NotFound from 'screens/Buyer/notfound/NotFound';
import MyProperty from 'screens/seller/my-property/MyProperty';
import VisitRequests from 'screens/seller/visit-requests/VisitRequests';
import AgentPropertyDetails from 'subscreens/Buyer/agents/AgentPropertyDetails';
import SellerAnalytics from 'screens/seller/selleranalytics/SellerAnalytics';
import KYCModel from 'screens/seller/kycmodal/KYCModel';
import SellerOtpVerification from 'screens/seller/otpverification/SellerOtpVerification';
import BuyerOtpVerification from 'screens/Buyer/otpverification/BuyerOtpVerification';
import AddProperty from 'subscreens/Seller/sellerproperty/AddProperty';
import PropertyViewScreen from 'subscreens/Seller/viewscreen/PropertyViewScreen';
import SellerProperties from 'subscreens/Admin/allsellers/SellerProperties';
import SellerForgotPassword from 'screens/seller/sellerforgotpassword/SellerForgotPassword';
import BuyerForgotPassword from 'screens/Buyer/buyerforgotpassword/BuyerForgotPassword';
import SellerResetPassword from 'screens/seller/sellerresetpassword/SellerResetPassword';
import BuyerResetPassword from 'screens/Buyer/buyerresetpassword/BuyerResetPassword';



const App = () => {
  return (
    <Routes>
      {/*===================== PUBLIC SCREENS ============================*/}

      <Route path='/' element={<Home />} />
      <Route path='/Properties' element={<Properties />} />
      <Route path="/property/:id" element={<PropertyDetails />} />
      <Route path='/about' element={<About />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/agents' element={<Agents />} />
      <Route path='/blogs' element={<Blogs />} />

      {/*======================= ADMIN DASHBOARD Routes ============================*/}

      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/subadmin" element={<SubAdmin />} />
      <Route path="/admin/buyer" element={<AllBuyers />} />
      <Route path="/admin/sellers" element={<AllSellers />} />
      <Route path="/admin/analytics" element={<Analytics />} />
      <Route path="/admin/adminkyc" element={<AdminKyc />} />
      <Route path="/admin/blogs" element={<ManageBlogs />} />
      <Route path="/admin/faqs" element={<Managefaqs />} />
      <Route path="/admin/profile" element={<AdminProfile />} />
      <Route path="/admin/notification" element={<Notification />} />
      <Route path="/admin/contact" element={<ContactManagement />} />
      <Route path="/admin/dispute" element={<DisputeManagement />} />
      <Route path="/admin/allsellers/:sellerId" element={<SellerProperties />} />
      <Route path="/admin/adminkyc" element={<AdminKyc />} />
      <Route path="/admin/auth" element={<AuthLogin />} />

      {/*======================= Seller Routes ============================*/}

      <Route path='/seller/kycmodal' element={<KYCModel />} />
      <Route path='/seller/dashboard' element={<SellerDashboard />} />
      <Route path='/seller/my-property' element={<MyProperty />} />
      <Route path='/seller/visit-requests' element={<VisitRequests />} />
      <Route path='/seller/messages' element={<SellerMessages />} />
      <Route path='/seller/analytics' element={<SellerAnalytics />} />
      <Route path='/seller/help-supports' element={<HelpSupports />} />
      <Route path='/seller/profile' element={<SellerProfile />} />
      <Route path='/seller/notification' element={<Notifications />} />
      <Route path='/seller/login' element={<SellerLogin />} />
      <Route path='/seller/signup' element={<Sellersignup />} />
      <Route path='/seller/setting' element={<SellerSettings />} />
      <Route path='/seller/kyc' element={<SellerKYC />} />
      <Route path='/seller/addproperty' element={<AddProperty />} />
      <Route path='/seller/viewscreen' element={<PropertyViewScreen />} />
      <Route path='/seller/otpverification' element={<SellerOtpVerification />} />
      <Route path='/seller/forgot-password' element={<SellerForgotPassword />} />
      <Route path='/seller/reset-password' element={<SellerResetPassword />} />

      {/*======================= Buyer Routes ============================*/}

      <Route path='/buyersidebar' element={<BuyerSideBar />} />
      <Route path='/buyerheader' element={<BuyerHeader />} />
      <Route path='/buyer/dashboard' element={<BuyerDashboard />} />
      <Route path='/buyer/properties' element={<BuyerProperty />} />
      <Route path='/buyer/map' element={<BuyerMap />} />
      <Route path='/buyer/chats' element={<BuyerChats />} />
      <Route path='/buyer/support' element={<BuyerSupport />} />
      <Route path='/buyer/profile' element={<BuyerProfile />} />
      <Route path='/buyer/notifications' element={<BuyerNotifications />} />
      <Route path='/buyer/visitreq' element={<BuyerRequest />} />
      <Route path='/buyer/login' element={<BuyerLogin />} />
      <Route path='/buyer/otpverification' element={<BuyerOtpVerification />} />
      <Route path='/buyer/forgot-password' element={<BuyerForgotPassword />} />
      <Route path='/buyer/reset-password' element={<BuyerResetPassword />} />
      <Route path='/buyer/signup' element={<BuyerSignup />} />
      <Route path='/buyer/agents/agentpropertydetails' element={<AgentPropertyDetails />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  );
}
export default App;
